export const BACKEND_APIS = {
	BRANDS: '/api/brands',
	MATCHERS: '/api/matchers',
	SESSION: '/api/session',
	SKU_DATA: '/backend/sku',
	UNMATCHED: '/api/unmatched',
	BACKEND: '/backend',
	BACKEND_ADMIN: '/backend/admin',
	BATCH_ADMIN: '/api/batch-admin',
	PRODUCTS_REVIEW: '/api/products-review',
	SCRAPING_DATA_REVIEW: '/api/scraping-data-review',
	SKU_CANDIDATES: '/api/sku-candidates',
	SKU_DUPLICATES: '/api/sku-duplicates',
	SKU_MANAGEMENT: '/api/sku-management',
	AUDIT_LOG: '/api/audit-log',
	RETAILER_PRODUCTS: '/api/retailer-products',
	RETAILER_BRANDS: '/api/retailer-brands',
	COMPETITOR_BRANDS: '/api/competitor-brands',
	PRODUCT_BRANDS: '/api/product-brands',
	VISIBILITY_BRANDS: '/api/visibility-brands',
	VT: '/api/vt'
}

const __MATCHERS_PATH = '/matchers'
export const MATCHERS_ROUTES = {
	PATH: __MATCHERS_PATH,
	TITLE: 'Matchers',
	SUBTITLE: '',

	SKUS_PATH: `${__MATCHERS_PATH}/skus`,
	SKUS_SUBTITLE: 'SKUs',
}

const REVERSE_MATCHERS_PATH = '/matcher'
export const REVERSE_MATCHER_ROUTES = {
	PATH: REVERSE_MATCHERS_PATH,
	TITLE: 'Matchers',
	SUBTITLE: '',

	REVERSE_PATH: `${REVERSE_MATCHERS_PATH}/reverse`,
	REVERSE_SUBTITLE: 'Reverse Mapper'
}

const RAW_MATCHERS_PATH = '/raw-matcher'
export const RAW_MATCHER_ROUTES = {
	PATH: RAW_MATCHERS_PATH,
	TITLE: 'Product to SKU',
	SUBTITLE: '',

	RAW_PATH: `${RAW_MATCHERS_PATH}/raw`,
	RAW_SUBTITLE: 'Raw Mapper'
}

const PRODUCTS_MATCHERS_PATH = '/products-matcher'
export const PRODUCTS_MATCHER_ROUTES = {
	PATH: PRODUCTS_MATCHERS_PATH,
	TITLE: 'Raw to Raw',
	SUBTITLE: '',

	PRODUCTS_PATH: `${PRODUCTS_MATCHERS_PATH}/products`,
	PRODUCTS_SUBTITLE: 'Products Mapper'
}

const __UNMATCHED_PATH = '/unmatched'
export const UNMATCHED_ROUTES = {
	PATH: __UNMATCHED_PATH,
	TITLE: 'Unmatched',
	SUBTITLE: '',

	NEW_PRODUCTS_PATH: `${__UNMATCHED_PATH}/new-products`,
	NEW_PRODUCTS_SUBTITLE: 'New Products'
}

export const SESSION_ROUTES = {
	AUTH_URL: '/auth',
	AUTH_TITLE: 'Authentication',

	LOGIN_URL: '/login',
	LOGIN_TITLE: 'Login',

	LOGOUT_URL: '/logout'
}

const __BRANDS_PATH = '/brands'
export const BRANDS_ROUTES = {
	PATH: __BRANDS_PATH,
	TITLE: 'Brands',
	SUBTITLE: '',
	
	CRUD_PATH: `${__BRANDS_PATH}/crud`,
	CRUD_TITLE: `Brand`,
}

const __BATCH_ADMIN_PATH = '/batch-admin'
export const BATCH_ADMIN_ROUTES = {
	PATH: __BATCH_ADMIN_PATH,
	TITLE: 'SKU Mapping Management',
	SUBTITLE: 'Manage and monitor batch processing workflows',
	
	LIST_PATH: `${__BATCH_ADMIN_PATH}/batches`,
	LIST_SUBTITLE: 'Batch Overview',
}

const __PRODUCTS_REVIEW_PATH = '/products-review'
export const PRODUCTS_REVIEW_ROUTES = {
	PATH: __PRODUCTS_REVIEW_PATH,
	TITLE: 'Products Review',
	SUBTITLE: 'Review mapped products and their SKU assignments',
}

const __SCRAPING_DATA_REVIEW_PATH = '/scraping-data-review'
export const SCRAPING_DATA_REVIEW_ROUTES = {
	PATH: __SCRAPING_DATA_REVIEW_PATH,
	TITLE: 'Scraping Data Review',
	// Says the two things a DIPI user will otherwise assume wrong: this is the
	// last capture per product, not a given day, and only products the scraper
	// has seen recently are in it.
	SUBTITLE: 'Last capture per product, for products seen in the last 30 days',
}

const __SKU_MANAGEMENT_PATH = '/sku-management'
export const SKU_MANAGEMENT_ROUTES = {
	PATH: __SKU_MANAGEMENT_PATH,
	TITLE: 'SKU Management',
	SUBTITLE: 'Manage and view SKU catalog by brand',
}

const __AUDIT_LOG_PATH = '/audit-log'
export const AUDIT_LOG_ROUTES = {
	PATH: __AUDIT_LOG_PATH,
	TITLE: 'Audit Log',
	SUBTITLE: 'View and search mapping audit trail',
}

const __USER_STATS_PATH = '/user-stats'
export const USER_STATS_ROUTES = {
	PATH: __USER_STATS_PATH,
	TITLE: 'User Stats',
	SUBTITLE: 'Review user mapping activity and productivity',
}

const __PRICE_ANALYSIS_PATH = '/price-analysis'
export const PRICE_ANALYSIS_ROUTES = {
	PATH: __PRICE_ANALYSIS_PATH,
	TITLE: 'Price Analysis',
	SUBTITLE: 'Analyze SKU prices across markets and sites',
}

const __RETAILER_PRODUCTS_PATH = '/retailer-products'
export const RETAILER_PRODUCTS_ROUTES = {
	PATH: __RETAILER_PRODUCTS_PATH,
	TITLE: 'Retailer Products',
	SUBTITLE: 'Review retailer catalog and product matches',
}

const __RETAILER_BRANDS_PATH = '/retailer-brands'
export const RETAILER_BRANDS_ROUTES = {
	PATH: __RETAILER_BRANDS_PATH,
	TITLE: 'Retailer Brands',
	SUBTITLE: 'Review and normalize each retailer\'s brands before launching matches',
}

const __COMPETITOR_BRANDS_PATH = '/competitor-brands'
export const COMPETITOR_BRANDS_ROUTES = {
	PATH: __COMPETITOR_BRANDS_PATH,
	TITLE: 'Competitor Brands',
	SUBTITLE: 'Normalize competitor product brands (per site) so they become raw2raw candidates',
}

const __CATEGORIES_PATH = '/categories'
export const CATEGORIES_ROUTES = {
	PATH: __CATEGORIES_PATH,
	TITLE: 'Categories',
	SUBTITLE: 'Category distribution of own and competitor catalogs',
}

const __SKU_CANDIDATES_PATH = '/sku-candidates'
export const SKU_CANDIDATES_ROUTES = {
	PATH: __SKU_CANDIDATES_PATH,
	TITLE: 'SKU Candidates',
	SUBTITLE: 'Review not-found products and create new SKUs',
}

const __SKU_DUPLICATES_PATH = '/sku-duplicates'
export const SKU_DUPLICATES_ROUTES = {
	PATH: __SKU_DUPLICATES_PATH,
	TITLE: 'SKU Duplicates',
	SUBTITLE: 'SKUs mapped to more than one product of the same site',
}

const __VISIBILITY_TRACKER_PATH = '/visibility-tracker'
export const VISIBILITY_TRACKER_ROUTES = {
	PATH: __VISIBILITY_TRACKER_PATH,
	TITLE: 'Visibility Tracker',
	SUBTITLE: 'Manual tagging of banners, sliders and product listings by retailer section',
	MY_TASKS_PATH: `${__VISIBILITY_TRACKER_PATH}/my-tasks`,
	MY_TASKS_TITLE: 'My tasks',
	ADMIN_PATH: `${__VISIBILITY_TRACKER_PATH}/admin`,
	ADMIN_TITLE: 'Admin',
	REVIEW_PATH: `${__VISIBILITY_TRACKER_PATH}/banners-review`,
	REVIEW_TITLE: 'Banners Review',
	PIPELINE_PATH: `${__VISIBILITY_TRACKER_PATH}/pipeline`,
	PIPELINE_TITLE: 'Pipeline',
	REVIEW_QUEUE_PATH: `${__VISIBILITY_TRACKER_PATH}/review-queue`,
	REVIEW_QUEUE_TITLE: 'Review Queue',
	RESOURCES_PATH: `${__VISIBILITY_TRACKER_PATH}/resources`,
	RESOURCES_TITLE: 'Resources',
	RESOURCE_MERGE_PATH: `${__VISIBILITY_TRACKER_PATH}/resource-merge`,
	RESOURCE_MERGE_TITLE: 'Resource Merge',
	RESOURCE_DETAIL_PATH: `${__VISIBILITY_TRACKER_PATH}/resource`,
	RESOURCE_DETAIL_TITLE: 'Resource Lookup',
	AI_COSTS_PATH: `${__VISIBILITY_TRACKER_PATH}/ai-costs`,
	AI_COSTS_TITLE: 'AI Costs',
	OPERATOR_METRICS_PATH: `${__VISIBILITY_TRACKER_PATH}/operator-metrics`,
	OPERATOR_METRICS_TITLE: 'Operator Metrics',
	MAPPING_METRICS_PATH: `${__VISIBILITY_TRACKER_PATH}/mapping-metrics`,
	MAPPING_METRICS_TITLE: 'Mapping Metrics',
}